import { object, string } from 'yup'
import parsePhoneNumber from 'libphonenumber-js'

const SCHEMA_PATH = 'phone'

export function phoneSchema(
  required = true,
  requiredMessage = 'Please enter phone number',
  validMessage = 'Please enter a valid number'
) {
  let schema = object()
    .shape({
      code: string(),
      number: string(),
    })
    .test(SCHEMA_PATH, validMessage, function () {
      // eslint-disable-next-line @typescript-eslint/no-invalid-this
      const { phone } = this.parent

      if (!required && (!phone || (!phone.code && !phone.number))) {
        return true
      }

      const concatenatedNumber = `${phone.code}${phone.number}`

      if (concatenatedNumber.length === 0) {
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        return this.createError({
          path: SCHEMA_PATH,
          message: requiredMessage,
        })
      }

      try {
        const phoneNumber = parsePhoneNumber(concatenatedNumber)
        return phoneNumber && phoneNumber.isValid()
      } catch (error) {
        return false
      }
    })

  if (required) {
    schema = schema.required(requiredMessage)
  }

  return schema
}
